module.exports={
    "over_size_message":"Bilden du laddade upp är över 10MB. Vi kommer att komprimera din fil för uppladdning. Klicka på \"Bekräfta\" för att fortsätta uppladdningen.",
    "file_type_error":"Filen du laddade upp är inte en bild! Försök att ladda upp igen.",
    "upload_error":"Uppladdningsfel! (Felkod: 2000) Försök igen.",
    "watermark_remove_over_size":"Bilden du laddade upp är över 5MB. Det rekommenderas att du använder vår gratis bildkompressor online. Klicka för att <a class=\"jump-link\" href=\"https://www.anymp4.com/sv/image-compressor-online/\">läs mer</a>",
    "watermark_remove_file_type_error":"Filen du laddade upp är inte en bild, ladda upp igen.",
    "watermark_remove_image_type_error":"Bildformatet stöds inte. Vi stöder endast JPG, JPEG, PNG och BMP.",
    "watermark_remove_upload_error":"Igenkänningsfel (felkod: 2001), försök igen...",
    "watermark_remove_processing":"Bearbetar bild...",
    "watermark_remove_not_save":"Området du valde kommer inte att behållas. Är du säker på att du vill beskära den?",
    "watermark_remove_back_home":"Aktuell status kommer inte att sparas. Är du säker på att du vill gå tillbaka till hemmet?",
    "watermark_remove_new_image":"Aktuell status kommer inte att sparas. Är du säker på att du vill välja en ny bild?",
    "watermark_select":"Välj",
    "watermark_select_area":"Välj området för vattenstämpeln du vill radera innan du klickar på Ta bort.",
    "watermark_beyond_12k":"Den valda bilden överskrider 12K upplösning. Vi beklagar att vi inte kan behandla det för närvarande",
    "watermark_beyond_pixel_1":"Den valda bildupplösningen överstiger <span>%spx</span><span>&times;%spx</span>. Det går inte att bearbeta, välj igen.",
    "watermark_beyond_pixel_2":"Besökare kan bara bearbeta <span>%s</span> bilder med en upplösning över <span>%spx</span>x<span>%spx</span>, vänligen logga in och fortsätt att använda.",
    "watermark_beyond_size_1":"Den valda bildstorleken överstiger <span>%sMB</span>. Det går inte att bearbeta, välj igen.",
    "watermark_beyond_size_2":"Den valda bildstorleken överstiger <span>%sMB</span>, men besökare kan bara bearbeta bilder som är mindre än <span>%sMB</span>. Logga in och fortsätt att använda.",
    "no_user_down":"Besökare kan bara ladda ner <span>%s</span> bilder med originalkvalitet. Logga in och fortsätt nedladdningen. Du kan också behålla 7-dagarshistoriken efter inloggning. Fortsätt att ladda ner bilder som är <span>%spx</span> breda eller höga.",
    "no_down_rights":"Det går inte att ladda ner HD-bilder med originalkvalitet, uppgradera din plan! Du kan också fortsätta att ladda ned bilder av låg kvalitet med <span>%spx</span>.",
    "error_40001":"Fel: 40001. Kontakta oss",
    "error_40099":"Fel: 40099. Kontakta oss",
    "down_btn":"Nedladdningen håller på att förberedas, vänta en sekund...",
    "noRemove_down_btn":"Du har inte gjort något för att ta bort vattenstämplar. Välj den vattenstämpel du vill ta bort och klicka på knappen Ta bort. Sedan kan du ladda ner din bild.",
    "history_open":"Öppnar den ändrade bilden, vänta ett ögonblick...",
    "maskRightsMonitor_info":"Sidan för förmånsuppgradering har öppnats på en ny flik och din plan kommer att synkroniseras automatiskt efter uppgraderingen.",
    "maskLoginMonitor_info":"Målsidan har öppnats, vänligen slutför inloggningen på den. Efter att ha loggat in eller registrerats framgångsrikt kommer den här sidan att synkroniseras automatiskt, vänligen stäng den inte.",
    "photo_rights_info":"<span><i class=\"num\">2</i> HD-bilder</span> med originalkvalitet kan laddas ner för närvarande. <a href=\"https://account.anymp4.com\" target=\"_blank\">Visa detaljer>></a>",
    "rights_original":"För att aktivera inställningen \"Använd bildförbättringsfunktionen för att minska kvalitetsförlusten\" måste du uppgradera ditt konto!",
    "Brush":"Borsta",
    "Lasso":"Lasso",
    "Polygonal":"Polygonal",
    "Eraser":"Suddgummi",
    "Free":"Fri",
    "More":"Mer:",
    "Select":"Välj",
    "Remove":"Ta bort",
    "BrushSize":"Penselstorlek:",
    "AspectRatio":"Bildförhållande:",
    "Upload":"Nytt foto",
    "History":"Historia",
    "Login":"Logga in",
    "MyAccount":"Mitt konto",
    "Logout":"Logga ut",
    "Usinghelp":"Använda hjälp >>",
    "Enhancer":"Använd funktionen Image Enhancer för att minska kvalitetsförlusten",
    "Download":"Ladda ner",
    "Guide":"Guide",
    "Polygonal1":"Polygonal",
    "Polygonal_info":"Klicka på vänster musknapp för att identifiera en punkt åt gången.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Tryck länge på vänster musknapp för att ta bort vattenstämpelområdet.",
    "Brush1":"Borsta:",
    "Brush_info":"Tryck länge på vänster musknapp för att välja exakt.",
    "Eraser1":"Suddgummi:",
    "Eraser_info":"Radera onödiga delar från det valda området.",
    "Click":"Klick",
    "the":"de",
    "click_info":"knappen för att börja utplåna den oönskade vattenstämpeln.",
    "PleaseUploadImages":"Ladda upp bilder.",
    "CropInfo":"När du har tagit bort vattenstämpeln kan du klicka på knappen Beskär för att beskära din bild innan du sparar, eller klicka på knappen Ladda ner för att spara den aktuella bilden direkt.",
    "Crop":"Beskära",
    "Back":"Tillbaka",
    "DownloadCropped":"Ladda ner Cropped",
    "Cancel":"Avbryt",
    "FreeWatermarkRemover":"Gratis vattenstämpelborttagare",
    "Processing":"Bearbetar...",
    "NewImage":"Ny bild",
    "Retry":"På nytt",
    "Yes":"Ja",
    "No":"Nej",
    "FailureFeedback":"Feedback om misslyckande",
    "removeTip":"När du har valt vattenstämpelområdet klickar du på Ta bort för att radera vattenstämpeln.",
    "rightDown":"Ladda ner bilder av låg kvalitet",
    "history_will":"Upphör att gälla efter",
    "Expired":"(Utgånget)",
	"uploadImage":"Ladda upp bild",
    "uploadImageInfo":"Eller släpp din bildfil här för att ta bort vattenstämpeln!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain TWO HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Obegränsat",
    "watermark_beyond_pixel_3":"Den valda bilden överskrider <span>%s&times;%s upplösning</span>, uppgradera din plan först.",
    "watermark_beyond_size_3":"Den valda bilden överstiger <span>%sMB</span>, uppgradera din plan först.",
    "no_user_login":"Nya användare som loggar in kan få TVÅ fördelar för nedladdning av originalbilder i HD.<span class=\"loginMaskbtn\">Logga in omedelbart>></span>",
    "Upgrade":"Uppgradera",
    "Loading":"Läser in…",
    "SelectAll":"Välj alla",
    "Open":"Öppet",
    "Delete":"Radera",
    "Clear":"Rensa ogiltig",
    "noHistory":"Ingen historia",
    "Close":"Stänga",
    "buyUserInfo":"grattis! Du har uppgraderat framgångsrikt. Gå tillbaka till startsidan och använd den här produkten.",
    "buyNoUserInfo":"Grattis! Du har uppgraderat framgångsrikt. Fördelarna har varit bundna till den e-postadress du lämnade när du uppgraderade. Använd kontot som är registrerat eller länkat till e-postadressen för att <span class=\"loginMaskbtn\">logga in för att använda förmåner</span>. Om du inte har registrerat eller länkat ett konto med e-postadressen, <span class=\"registerMaskbtn\">använd e-postadressen för att registrera ett konto</span> eller länka andra konton till denna e- mailadress för att använda förmåner.",
    "GetStarted":"Komma igång",
    "AccessTo":"Tillgång till:",
    "imagesOfwatermarkremoval":"bilder på borttagning av vattenstämpel",
    "upTo":"Upp till",
    "perImage":"per bild",
    "Support":"Stöd",
    "resolution":"upplösning",
    "PrepaidPackage":"Förbetalt paket",
    "PayasYouGo":"Betala när du går",
    "TaxIncl":"Inkl skatt.",
    "Checkout":"Kolla upp",
    "imagesDay":"bilder/dag",
    "imagesMonthly":"bilder/månad",
    "image":"bild",
    "images":"bilder",
    "imageSize":"bildstorlek",
    "buyInfo1":"Tredjeparts <span>enhancer</span> integrationer",
    "buyInfo2":"Redigeringshistoriken är giltig i 7 dagar",
    "buyInfo3":"Prioriterad bearbetning",
    "buyInfo4":"7x24 kundsupport",
    "buyInfo5":"Förfallit efter 24 timmar",
    "buyInfo6":"Inget abonnemang. Ingen automatisk förnyelse!",
    "buyInfo7":"Tillgänglig för användning när som helst för alltid",
    "dayPlan":"1-dagarsplan",
    "Lifetime":"Livstid",
}